export var FilterItemTypes;
(function (FilterItemTypes) {
    FilterItemTypes["Flag"] = "flag";
    FilterItemTypes["Range"] = "range";
    FilterItemTypes["List"] = "list";
    FilterItemTypes["FilterableList"] = "filterable";
    FilterItemTypes["Text"] = "text";
})(FilterItemTypes || (FilterItemTypes = {}));
